export function sortAlphabetical(itemA: string, itemB: string) {
  const nameA = itemA.toLowerCase();
  const nameB = itemB.toLowerCase();

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
}
